<div [fxHide]="viewMode !== 'LADDER'" fxLayout="column" class="page">
    <div fxFlex="0 0 calc(100vh-70px)" fxLayout="column">
        <div class="alm-trader-top-bar" fxFlex="0 0 auto" fxLayout="column">
            <div fxLayout="row" class="liquitics-box">
                <div fxFlex="1 1 auto" fxLayout="row">
                    <span fxFlex="0 0 150px" class="top-bar-label">Ladder Type: </span>
                    <p-selectButton [options]="ladderConfigs" [(ngModel)]="selectedLadderConfig"
                        (onChange)="onLadderConfig()"></p-selectButton>
                </div>
                <div fxFlex="1000 0 auto" fxLayoutAlign="stretch"></div>
            </div>
            <div fxLayout="row" class="liquitics-box">
                <div fxFlex="1 1 auto" fxLayout="row">
                    <span fxFlex="0 0 150px" class="top-bar-label">Break Down by: </span>
                    <p-selectButton [options]="breakDownConfigs" [(ngModel)]="selectedBreakDownConfig"
                        (onChange)="onBreakDownConfig()"></p-selectButton>
                </div>
                <div fxFlex="1000 0 auto" fxLayoutAlign="stretch"></div>
            </div>
            <div fxLayout="row">
                <div fxFlex="1 1 auto" fxLayout="row" class="liquitics-box">
                    <div fxFlex="1 1 auto" *ngIf="selectedLadderConfig?.ladderStructureType === 'TENOR_GROUPINGS'">
                        <mat-slide-toggle fxFlex="0 1 auto" ngDefaultControl [(ngModel)]="showSecondaryLadder"
                            color="primary" (toggleChange)="onShowSecondaryLadder($event)">
                            Show Secondary Ladder as of: </mat-slide-toggle>
                        <p-selectButton [options]="comparisonOperatingDates"
                            [(ngModel)]="selectedComparisonOperatingDate" (onChange)="onComparisonOperatingDate()">
                        </p-selectButton>
                    </div>
                </div>
                <div fxFlex="1 1 auto" fxLayout="row" class="liquitics-box">
                    <mat-slide-toggle fxFlex="0 1 auto" ngDefaultControl [(ngModel)]="showDelta" color="primary">
                        Show
                        Delta
                    </mat-slide-toggle>
                </div>
                <div fxFlex="1 1 auto" fxLayout="row" class="liquitics-box">
                    <mat-chip-list fxFlex="1 1 auto" fxLayout="row" #chipList aria-label="Break Down Order" cdkDropList
                        cdkDropListOrientation="horizontal" (cdkDropListDropped)="breakDownOrderDrop($event)">
                        Order:
                        <mat-chip *ngFor="let bdl of breakDownLevels" [selectable]="false" [removable]="false" cdkDrag>
                            {{bdl.label}}
                        </mat-chip>
                    </mat-chip-list>
                </div>
                <div fxFlex="1000 0 auto" fxLayoutAlign="stretch"></div>
            </div>
        </div>
        <div fxLayout="column">
            <div *ngIf="!ladderTreeNodes && !isInError" class="splash-screen">
                <!--<div class="splash-loader"></div>-->
                <img class="splash-logo" align="center" height="40px" src="assets/liquitics-logo.svg" />
            </div>
            <div *ngIf="isInError" class="error-icon-wrapper" fxFlex="1 1 100%">
                <mat-icon class="error-icon">error_outline</mat-icon>
            </div>
            <div fxLayout="row" fxLayoutGap="1em">
                <div fxFlex="0 1 auto" style="text-align: left">
                    <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
                    <input type="text" pInputText size="50" placeholder="Filter" (input)="applyGlobalFilter($event)"
                        style="width:auto">
                </div>
            </div>
            <app-alm-break-down-ladder-table #bdlt1 *ngIf="ladderTreeNodes" class="liquitics-box"
                [ladderTreeNodes]="ladderTreeNodes" [ladderColumnNames]="ladderColumnNames"
                [showDelta]="showDelta && selectedLadderConfig?.ladderStructureType === 'TENOR_GROUPINGS'"
                (breakDownNodeSelected)="ladder1BreakDownNodeSelected($event)"
                (breakDownNodeExpanded)="ladder1BreakDownNodeExpansionChanged($event)"
                (breakDownNodeCollapsed)="ladder1BreakDownNodeExpansionChanged($event)">
            </app-alm-break-down-ladder-table>
            <app-alm-break-down-ladder-table #bdlt2 *ngIf="showSecondaryLadder && secondaryLadderTreeNodes"
                class="liquitics-box" [ladderTreeNodes]="secondaryLadderTreeNodes"
                [ladderColumnNames]="ladderColumnNames"
                [showDelta]="showDelta && selectedLadderConfig?.ladderStructureType === 'TENOR_GROUPINGS'"
                (breakDownNodeSelected)="ladder2BreakDownNodeSelected($event)"
                (breakDownNodeExpanded)="ladder2BreakDownNodeExpansionChanged($event)"
                (breakDownNodeCollapsed)="ladder2BreakDownNodeExpansionChanged($event)">
            </app-alm-break-down-ladder-table>
        </div>
    </div>
</div>
<div [fxHide]="viewMode !== 'REPORT'" fxLayout="column" class="page">
    <div fxFlex="1 1 100%" fxLayout="column">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Top N Reports</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <app-top-n-table fxFlex="1 1 100%" [configs]="reportQueryTopNTableConfigs" [previewCount]="3"
                    [showExpansion]="true">
                </app-top-n-table>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-header>
                <mat-card-title>Statistics Reports</mat-card-title>
            </mat-card-header>
            <mat-card-content fxLayout="row">
                <app-alm-break-down-ladder-table *ngIf="reportQueryTreeNodes" fxFlex="1 1 60%" class="liquitics-box"
                    [ladderTreeNodes]="reportQueryTreeNodes" [ladderColumnNames]="['Count','Notional']"
                    [groupingColHeaderWidth]="'60%'" (breakDownNodeSelected)="statisticsBreakDownNodeSelected($event)">
                </app-alm-break-down-ladder-table>
                <div fxFlex="1 1 40%" fxLayout="column">
                    <app-alm-historical-chart class="chartwrapper" fxFlex="1 1 30vh" title="Historical Counts"
                        [historicalData]="countHistoricalData" index=0></app-alm-historical-chart>
                    <app-alm-historical-chart class="chartwrapper" fxFlex="1 1 30vh" title="Historical Notionals"
                        [historicalData]="notionalHistoricalData" index=1></app-alm-historical-chart>
                </div>

            </mat-card-content>

        </mat-card>
    </div>
</div>
<app-simulation fxFlex="1 1 auto" [fxHide]="viewMode != 'SIMULATION'">
</app-simulation>